export const ListItem: React.FC<React.PropsWithChildren> = ({ children }) => <li>{children}</li>;

ListItem.displayName = 'Nav.ListItem';
